import { pagesConfig } from '../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../shared/analytics/module-list';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ClickableCard from '../../shared/clickable-card';
import { Outlet, useNavigate } from 'react-router-dom';
import { useRouteMatch } from '../../shared/useRouteMatch';

export default function InsightsDetailViewsPage() {
  const navigate = useNavigate();
  const BREADCRUMBS = [
    { label: ModuleList.modules.insights.name },
    { label: pagesConfig.insightsDetailViews.name },
  ];

  const insightDetailViewsLink = `${pagesConfig.insights.link}/${pagesConfig.insightsDetailViews.link}`;
  const isSubPageClicked = useRouteMatch([
    `/${insightDetailViewsLink}/${pagesConfig.insightsIamMemberSummary.link}`,
    `/${insightDetailViewsLink}/${pagesConfig.insightsProjectMemberRoles.link}`,
  ]);

  const insightsCards = [
    pagesConfig.insightsIamMemberSummary,
    pagesConfig.insightsProjectMemberRoles,
  ].map(({ name, link }) => ({
    title: name,
    path: `/${insightDetailViewsLink}/${link}`,
  }));

  if (isSubPageClicked) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage breadcrumbs={BREADCRUMBS} shouldAllowHeightToScroll>
      <Box p={1}>
        <Typography variant="body1">
          These dashboards are for single elements, for more granular data
          exploration.
        </Typography>
        <Stack
          direction="row"
          sx={{
            mt: 3,
            gap: 3,
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {insightsCards.map(({ title, path }) => (
            <ClickableCard
              key={path}
              title={title}
              onClick={() => navigate(path)}
            />
          ))}
        </Stack>
      </Box>
    </SimpleBreadcrumbsPage>
  );
}
